import { get, post, patch, deleteVendorItem } from './VIRSApi';

class ItemApi {
  static async getItemsByVendorCode(vendorCode) {
    return get(`vendors/${vendorCode}/vendorItems`);
  }

  static async getItemByVendorItemId(vendorCode, vendorItemId) {
    return get(`vendors/${vendorCode}/vendorItems/${vendorItemId}`);
  }

  static async post(vendorCode, body) {
    return post(`vendors/${vendorCode}/vendorItems`, body);
  }

  static async patch(vendorCode, body, vendorItemId) {
    return patch(`vendors/${vendorCode}/vendorItems/${vendorItemId}`, body);
  }

  // GDPS-1483 delete
  static async delete(vendorCode, vendorItemId) {
    // We could not use "delete" because it is a keyword in 
    // VIRSAPi.js
    return deleteVendorItem(`vendors/${vendorCode}/vendorItems/${vendorItemId}`);
  }

  static async getItemsByItemId(vendorCode, itemId) {
    return get(`vendors/${vendorCode}/vendorItems?itemId=${itemId}`);
  }

}

export default ItemApi;
